import { defineComponent as _defineComponent } from 'vue'

import { Icon } from "@iconify/vue2"


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckStep',
  props: {
  check: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  iconColor: {
    type: String,
    default: "red",
  },
},
  setup(__props) {



return { __sfc: true,Icon }
}

})